import { ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LangContext";

const BRANDS = [
  ["InfoGuard", "infoguard.ch.svg"], ["Oneconsult", "oneconsult.com.svg"], ["Compass Security", "compass-security.com.svg", "h-14"], ["Redguard", "redguard.ch.svg"],
  ["Swiss Infosec", "infosec.ch.svg"], ["ELCA Security", "elcasecurity.ch.svg"], ["Asperiq", "asperiq.com.svg"], ["Omicron", null],
  ["Cybersec Services", "cybersecservices.ch.png"], ["Sphynx", "sphynx.ch.png"], ["Cisco", "cisco.com.svg"], ["Palo Alto Networks", "paloaltonetworks.com.svg"],
  ["IBM Security", "ibm.com.svg"], ["Check Point", "checkpoint.com.svg"], ["Fortinet", "fortinet.com.svg"], ["Accenture Security", "accenture.com.svg"],
  ["Thales", "thalesgroup.com.svg"], ["Atos", "atos.net.png"], ["Bitdefender", "bitdefender.com.webp"], ["Darktrace", "darktrace.com.svg"],
];

const Brand = ({ name, file, h = "h-9" }) => (
  <span className="flex items-center justify-center h-14 px-10 shrink-0 transition-transform duration-300 hover:scale-110">
    {file
      ? <img src={`/logos/full/${file}`} alt={name} title={name} loading="lazy" className={`${h} w-auto max-w-[180px] object-contain`} />
      : <span className="font-display text-2xl font-bold tracking-wide text-[#1f4e8c]">{name.toUpperCase()}</span>}
  </span>
);

export const SecurityLeadersMarquee = () => {
  const { tr } = useLang();
  return (
    <section data-testid="security-leaders-marquee" dir="ltr" className="bg-white border-y border-[#e4e4e7] py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-6">
        <span className="text-[10px] uppercase tracking-[0.25em] font-mono text-[#E0262C] inline-flex items-center gap-2">
          <ShieldCheck className="w-3.5 h-3.5" /> {tr("Leader mondiali della cybersecurity", "World cybersecurity leaders")}
        </span>
      </div>
      <div className="marquee overflow-hidden">
        <div className="marquee-track items-center" style={{ "--marquee-dur": "80s" }}>
          {[...BRANDS, ...BRANDS].map(([n, f, h], i) => <Brand key={i} name={n} file={f} h={h} />)}
        </div>
      </div>
      <p className="max-w-7xl mx-auto px-6 lg:px-10 mt-6 text-[10px] text-[#a1a1aa]">
        {tr("Riferimenti del settore. I marchi appartengono ai rispettivi proprietari; nessuna affiliazione, partnership o rapporto commerciale con Aurora-ADV o PIXAWEB Sagl.",
          "Industry references. Trademarks belong to their respective owners; no affiliation, partnership or business relationship with Aurora-ADV or PIXAWEB Sagl.")}
      </p>
    </section>
  );
};
